import { useMediaQuery, useTheme } from '@mui/material';

export default () => useMediaQuery(useTheme().breakpoints.down('tablet'));
